import { type WorkspaceAgentPanelResizeEdges } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentPanelResizeEdges';

export type GetWorkspaceAgentPanelResizedWidthParams = {
  deltaX: number;
  resize: WorkspaceAgentPanelResizeEdges;
  startWidth: number;
};

export type GetWorkspaceAgentPanelResizedHeightParams = {
  deltaY: number;
  resize: WorkspaceAgentPanelResizeEdges;
  startHeight: number;
};

export const getWorkspaceAgentPanelResizedWidth = ({
  deltaX,
  resize,
  startWidth,
}: GetWorkspaceAgentPanelResizedWidthParams): number => {
  if (resize.left) {
    return startWidth - deltaX;
  }

  if (resize.right) {
    return startWidth + deltaX;
  }

  return startWidth;
};

export const getWorkspaceAgentPanelResizedHeight = ({
  deltaY,
  resize,
  startHeight,
}: GetWorkspaceAgentPanelResizedHeightParams): number => {
  if (resize.top) {
    return startHeight - deltaY;
  }

  if (resize.bottom) {
    return startHeight + deltaY;
  }

  return startHeight;
};
